import React, { Component } from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import Input from '@liveauctioneers/caterwaul-components/lib/Input/Input';
import isEqual from 'react-fast-compare';
import { email as isValidEmail } from '@/utils/validation';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './SignUpEmail.module.scss';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

type Props = {
    bidderExists: boolean;
    error: string;
    noBodyMargins?: boolean;
    setEmail: Function;
    submitCreateAccount: Function;
    submitted: boolean;
};

type State = {
    agree: boolean;
    email: string;
    emailValid: boolean;
    showError: boolean;
};

export default class SignUpEmail extends Component<Props, State> {
    defaultProps = {
        noBodyMargins: false,
    };

    state = {
        agree: false,
        email: '',
        emailValid: true,
        noBodyMargins: false,
        showError: false,
    };

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    onValueChange = (event: any) => {
        const newState = {};
        newState[event.target.id] = event.target.value;
        this.setState(newState);
    };

    onAgreeValueChange = (event: any) => {
        const newState = { agree: event.target.checked };
        this.setState(newState);
    };

    onSignUp = () => {
        const email = this.state.email.trim();
        const emailValid = isValidEmail(email);
        const agree = this.state.agree;
        this.setState({ emailValid });
        if (emailValid) {
            this.props.setEmail(email);
            this.props.submitCreateAccount(email, agree);
        }
    };

    enterButton = () => {
        this.setState({ showError: true });
    };

    exitButton = () => {
        this.setState({ showError: false });
    };

    render() {
        const { bidderExists, error, noBodyMargins, submitted } = this.props;

        const { agree, email, emailValid, showError } = this.state;

        let errorMessage: React.ReactNode = '';
        const errorOnPage = !emailValid || (error && !bidderExists);

        const tosLink = (
            <Link rel="noopener" target="_blank" to="/termsandconditions">
                <FormattedMessage id="signUpModal.termsLink" />
            </Link>
        );
        const privacyLink = (
            <Link rel="noopener" target="_blank" to="/privacy">
                <FormattedMessage id="signUpModal.privacyLink" />
            </Link>
        );
        const cookieLink = (
            <Link rel="noopener" target="_blank" to="/cookie-policy">
                <FormattedMessage id="signUpModal.cookieLink" />
            </Link>
        );

        if (!emailValid) {
            errorMessage = <FormattedMessage id="signUpModal.invalidEmail" />;
        } else if (error && !bidderExists) {
            errorMessage = <FormattedMessage id="signUpModal.error" />; // we could show the error
        }

        return (
            <div className={classNames(styles.body, { [styles.bodyMargin]: !noBodyMargins })}>
                <Input
                    autoCapitalize="false"
                    autoComplete="false"
                    autoCorrect="false"
                    e2e="joinModalEmail"
                    errorMessage={errorMessage}
                    id="email"
                    label={<FormattedMessage id="signUpModal.username" />}
                    onChange={this.onValueChange}
                    valid={!errorOnPage}
                />
                <Checkbox checked={agree} className={styles['check-box']} onChange={this.onAgreeValueChange}>
                    <FormattedMessage id="signUpModal.acceptText" values={{ cookieLink, privacyLink, tosLink }} />
                </Checkbox>
                <div className={styles.links} onMouseEnter={this.enterButton} onMouseLeave={this.exitButton}>
                    <Button
                        className={styles.submit}
                        disabled={submitted || !email || !agree}
                        e2e="joinModalStartNow"
                        onClick={this.onSignUp}
                        primary
                        red
                    >
                        {!submitted ? <FormattedMessage id="signUpModal.submit" /> : <Throbber colorWhite />}
                    </Button>
                </div>
                {showError && email && !agree && (
                    <Text caption colorError>
                        <FormattedMessage id="signUpModal.termsError" />
                    </Text>
                )}
            </div>
        );
    }
}
